import { fork, all } from 'redux-saga/effects';
import {
  loadAppSaga,
  loadReferralDetailsSaga,
  refreshSessionSaga
} from './App/sagas';
import {
  loadTransactionsSaga,
  downloadCsvSaga
} from './App/Merchants/MerchantTransaction/sagas';
import { loadCommissionPayoutSettingsSaga } from './App/CommissionPayouts/sagas';
import { loadCommissionDueIndexSaga } from './App/CommissionPayouts/CommissionDueIndex/sagas';
import {
  commissionDueShowSaga,
  commissionDueUpdateShowSaga
} from './App/CommissionPayouts/CommissionDueShow/sagas';
import {
  commissionPaidShowSaga,
  commissionPaidUpdateShowSaga,
  downloadCommissionPaidShowCsvSaga
} from './App/CommissionPayouts/CommissionPaidShow/sagas';
import {
  loadCommissionPaidIndexSaga,
  downloadCommissionPaidIndexCsvSaga
} from './App/CommissionPayouts/CommissionPaidIndex/sagas';
import { marketingSaga, loadMarketingFilesSaga } from './App/Marketing/sagas';
import { loadStatisticsSaga } from './App/Dashboard/Statistics/sagas';
import { loadReferralBankDetailsSaga } from './App/Account/BankAccount/sagas';
import { loadReferralCryptoWalletsSaga } from './App/Account/CryptoWallets/sagas';
import { logoutSaga } from './App/SignIn/sagas';
import { loadMerchantApplicationSaga } from './App/Merchants/MerchantRegistrations/RegistrationForms/sagas';
import {
  loadFailedMerchantsSaga,
  deleteFailedMerchantSaga,
  deleteAllFailedMerchantsSaga
} from './App/Merchants/MerchantRegistrations/sagas';
import {
  loadDirectMerchantsSaga,
  downloadDirectMerchantsCsvSaga
} from './App/Merchants/DirectMerchants/DirectMerchantsIndex/sagas';
import { loadDirectMerchantSaga } from './App/Merchants/DirectMerchants/DirectMerchantsShow/sagas';
import {
  loadReferredPartnersIndexSaga,
  downloadReferredPartnersIndexCsvSaga
} from './App/Partners/ReferredPartnersIndex/sagas';
import { loadReferredPartnersShowSaga } from './App/Partners/ReferredPartnersShow/sagas';
// import { loadReferredPartnerStatisticsSaga } from './App/Partners/Statistics/sagas';

const sagas = [
  loadAppSaga,
  loadTransactionsSaga,
  downloadCsvSaga,
  marketingSaga,
  loadCommissionDueIndexSaga,
  loadCommissionPaidIndexSaga,
  downloadCommissionPaidIndexCsvSaga,
  loadCommissionPayoutSettingsSaga,
  commissionDueShowSaga,
  commissionDueUpdateShowSaga,
  commissionPaidShowSaga,
  commissionPaidUpdateShowSaga,
  downloadCommissionPaidShowCsvSaga,
  loadReferralDetailsSaga,
  loadReferralBankDetailsSaga,
  loadReferralCryptoWalletsSaga,
  loadStatisticsSaga,
  refreshSessionSaga,
  // loadPartnersSaga,
  loadMarketingFilesSaga,
  logoutSaga,
  loadMerchantApplicationSaga,
  loadFailedMerchantsSaga,
  deleteFailedMerchantSaga,
  deleteAllFailedMerchantsSaga,
  downloadDirectMerchantsCsvSaga,
  loadDirectMerchantSaga,
  loadDirectMerchantsSaga,
  loadReferredPartnersIndexSaga,
  downloadReferredPartnersIndexCsvSaga,
  loadReferredPartnersShowSaga
  // loadReferredPartnerStatisticsSaga
];

function* globalSagas() {
  const globalSagasForks = sagas.map(saga => fork(saga));

  yield all(globalSagasForks);
}

export default globalSagas;
